export const clearedDreamFilters = {
    selectedDifficulty: 0,
    selectedCampaignId: 0,
    selectedEmotion: "",
    selectedAttributes: [],
    excludedAttributes: [],
    onlyShowMasterDreams: false,
    onlyShowDreamsToReview: false,
    onlyShowTodaysDreams: false,
    onlyShowAdjacentDreams: false,
    searchText: "",
    randomDream: undefined,
};
